var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconePressao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 537,
    height: 392,
    viewBox: "0 0 537 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444.241 270.405H108.639C65.273 270.405 30.0054 235.601 30.0054 192.828C30.0054 186.184 30.8452 179.614 32.4873 173.319C41.4628 139.141 72.7744 115.252 108.639 115.252C113.379 115.252 118.193 115.693 122.97 116.558L135.286 118.804L139.727 107.264C157.603 60.7914 203.47 29.5951 253.87 29.5951C257.77 29.5951 261.913 29.8527 266.914 30.3681C279.771 31.7116 292.404 35.1534 304.477 40.5644C333.792 53.7607 357.023 78.2761 368.238 107.834L374.415 124.104L389.716 115.491C395.463 112.27 402.218 111.221 408.973 112.841C419.423 115.344 427.241 123.718 428.865 134.153L430.843 146.687H443.681L444.726 146.65C479.098 146.926 506.976 174.571 506.976 208.528C506.976 242.632 478.818 270.387 444.222 270.405H444.241ZM455.269 117.681C448.645 101.061 434.22 88.3988 416.064 84.0736C407.518 82.0307 398.71 81.9755 390.35 83.8528C374.937 53.1166 348.794 27.9755 316.923 13.638C301.902 6.88344 286.134 2.6135 270.086 0.920245C263.984 0.276074 258.834 0 253.852 0C195.073 0 141.238 34.0859 116.346 85.9509C63.9482 82.2699 16.4769 116.227 3.45218 165.92C1.15699 174.626 0 183.699 0 192.847C0 251.926 48.7402 300 108.639 300H444.259C495.407 299.982 537 258.939 537 208.528C537 161.761 501.229 123.074 455.269 117.681Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382 261.5C382 330.922 327.046 387 259.5 387C191.954 387 137 330.922 137 261.5C137 192.078 191.954 136 259.5 136C327.046 136 382 192.078 382 261.5Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5 160V199.4",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M180.7 199.399L205.325 224.024",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M313.675 224.024L338.3 199.399",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M170.85 288.05H200.4",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5 288.05L269.35 228.95",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M318.6 288.05H348.15",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.025 317.61H180.7C168.33 301.146 161 280.678 161 258.5C161 204.1 205.1 160 259.5 160C313.9 160 358 204.1 358 258.5C358 280.678 350.67 301.146 338.3 317.61L293.975 317.6",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.5 347.15C275.82 347.15 289.05 333.921 289.05 317.6C289.05 301.28 275.82 288.05 259.5 288.05C243.179 288.05 229.95 301.28 229.95 317.6C229.95 333.921 243.179 347.15 259.5 347.15Z",
    stroke: "white",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconePressao);
export default __webpack_public_path__ + "static/media/iconePressao.304e71c15f6cd5592309648355e672e1.svg";
export { ForwardRef as ReactComponent };